import { useState } from 'react';
import { login } from './api';

/**
 * Login de contratos.eneural.org. Postea al /auth compartido del panel-api: mismos
 * usuarios que el panel, sin padrón propio. Acepta cualquier rol que el backend deje
 * pasar — la frontera de acceso real la imponen los endpoints de contratos-api
 * (solo_admin / lectura), no este formulario. Sin registro: los usuarios de contratos
 * los da de alta un admin desde el panel.
 */
export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!username.trim() || !password) {
      setError('Completa usuario y clave.');
      return;
    }
    setCargando(true);
    setError('');
    try {
      const data = await login(username.trim(), password);
      onLogin(data.role || '');
    } catch (e) {
      const status = e.response?.status;
      setError(
        status === 401 ? 'Usuario o clave incorrectos.' :
        status === 403 ? 'Tu usuario no tiene permiso para entrar aquí.' :
        !e.response ? 'No se pudo conectar con el servidor.' :
        e.response?.data?.detail || 'No se pudo iniciar sesión.'
      );
    } finally {
      setCargando(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: 'var(--bg-void)' }}>
      <form className="nv-card" style={{ width: '100%', maxWidth: 360 }} onSubmit={handleSubmit}>
        <div className="nv-card-title" style={{ justifyContent: 'center', marginBottom: 6, fontSize: 16 }}>
          Netvoice · Contratos
        </div>
        <div style={{ textAlign: 'center', fontSize: 11.5, color: 'var(--text-secondary)', marginBottom: 20 }}>
          Gestión documental de contratos
        </div>

        <div className="nv-form-field" style={{ marginBottom: 12 }}>
          <label className="nv-label" htmlFor="username">Usuario</label>
          <input
            id="username"
            className="nv-input"
            type="text"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            disabled={cargando}
            autoFocus
          />
        </div>

        <div className="nv-form-field" style={{ marginBottom: 18 }}>
          <label className="nv-label" htmlFor="password">Clave</label>
          <input
            id="password"
            className="nv-input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={cargando}
          />
        </div>

        {error && <div className="nv-alert nv-alert-err" style={{ marginBottom: 14 }}>{error}</div>}

        <button className="nv-btn nv-btn-primary" type="submit" disabled={cargando} style={{ width: '100%', justifyContent: 'center' }}>
          {cargando ? 'Iniciando sesión…' : 'Inicia sesión'}
        </button>
      </form>
    </div>
  );
}
